<div class="feature-flag-form">
  <h2 class="form-title">{{ isEditMode ? 'Edit' : 'Create' }} Feature Flag</h2>

  <div class="loading-indicator" *ngIf="loading"><span class="spinner"></span> Loading feature flag...</div>

  <div class="error-message" *ngIf="errorMessage">
    <p>{{ errorMessage }}</p>
    <button id="e2e-retry-load" mat-button color="primary" *ngIf="isEditMode" (click)="loadFeatureFlag()">Retry</button>
  </div>

  <form [formGroup]="flagForm" (ngSubmit)="onSubmit()" *ngIf="!loading" class="flag-form">
    <!-- Basic Information -->
    <div class="form-section">
      <h3>Basic Information</h3>

      <div class="form-group">
        <label for="flag-id">ID *</label>
        <input
          id="flag-id"
          type="text"
          formControlName="id"
          placeholder="my-feature-flag"
          [attr.disabled]="isEditMode ? true : null"
        />
        <div class="form-error" *ngIf="hasError('id', 'required')">ID is required.</div>
        <div class="form-error" *ngIf="hasError('id', 'pattern')">
          ID must contain only letters, numbers, hyphens, and underscores.
        </div>
        <div class="form-help">
          A unique identifier for the feature flag. Use lowercase letters, numbers, hyphens, and underscores only.
        </div>
      </div>

      <div class="form-group">
        <label for="flag-name">Name *</label>
        <input id="flag-name" type="text" formControlName="name" placeholder="My Feature Flag" />
        <div class="form-error" *ngIf="hasError('name', 'required')">Name is required.</div>
        <div class="form-help">A human-readable name for the feature flag.</div>
      </div>

      <div class="form-group">
        <label for="flag-description">Description</label>
        <textarea
          id="flag-description"
          formControlName="description"
          placeholder="Describe the purpose of this feature flag"
          rows="3"
        ></textarea>
        <div class="form-help">Optional description of what this feature flag controls and how it's used.</div>
      </div>
    </div>

    <!-- Rule Configuration -->
    <div class="form-section">
      <h3>Rule Configuration</h3>

      <div class="form-group">
        <label for="rule-type">Rule Type *</label>
        <select id="rule-type" [formControl]="ruleTypeControl" (change)="onRuleTypeChange($event.target.value)">
          <ng-container *ngFor="let type of ruleTypes">
            <option [value]="type.value" [disabled]="!advancedRuleBuilder && type.value === 'group'">
              {{ type.label }}
            </option>
          </ng-container>
        </select>
        <div class="form-help">The type of rule determines how the feature flag is evaluated.</div>
      </div>

      <!-- Boolean Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'boolean'" formGroupName="rule">
        <div class="boolean-rule">
          <label>Value:</label>
          <div class="toggle-container">
            <div class="toggle-option">
              <input type="radio" id="boolean-true" formControlName="value" [value]="true" />
              <label for="boolean-true">Always Enabled</label>
            </div>
            <div class="toggle-option">
              <input type="radio" id="boolean-false" formControlName="value" [value]="false" />
              <label for="boolean-false">Always Disabled</label>
            </div>
          </div>
          <div class="form-help">A simple on/off switch for the feature flag.</div>
        </div>
      </div>

      <!-- Email Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'email'" formGroupName="rule">
        <cbre-email-rule [parentForm]="flagForm"></cbre-email-rule>
      </div>

      <!-- User Group Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'userGroup'" formGroupName="rule">
        <cbre-user-group-rule [parentForm]="flagForm"></cbre-user-group-rule>
      </div>

      <!-- User Role Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'userRole'" formGroupName="rule">
        <cbre-user-role-rule [parentForm]="flagForm"></cbre-user-role-rule>
      </div>

      <!-- Region Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'region'" formGroupName="rule">
        <cbre-region-rule [parentForm]="flagForm"></cbre-region-rule>
      </div>

      <!-- Line of Business Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'lineOfBusiness'" formGroupName="rule">
        <cbre-line-of-business-rule [parentForm]="flagForm"></cbre-line-of-business-rule>
      </div>

      <!-- Group Rule -->
      <div class="rule-config" *ngIf="selectedRuleType === 'group' && advancedRuleBuilder" formGroupName="rule">
        <cbre-group-rule [parentForm]="flagForm"></cbre-group-rule>
      </div>
    </div>

    <!-- Form Actions -->
    <div class="form-actions">
      <button mat-button color="primary" type="button" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
        <span class="spinner" *ngIf="submitting"></span>
        {{ submitting ? 'Saving...' : isEditMode ? 'Update' : 'Create' }}
      </button>
    </div>
  </form>
</div>
